import { appConfig } from '../../configs/app-config';

import { API_VERSION } from '../../constants/api-constants';
import ReportMetaFields from './ReportMetaFields';
import ReportMetaFieldsV2 from './ReportMetaFieldsV2';

export const ReportMetaFieldsWrapper = appConfig.apiVersion === API_VERSION.V2 ? ReportMetaFieldsV2 : ReportMetaFields;